import { render, staticRenderFns } from "./box-tool.vue?vue&type=template&id=ef913396&scoped=true"
import script from "./box-tool.vue?vue&type=script&lang=js"
export * from "./box-tool.vue?vue&type=script&lang=js"
import style0 from "./box-tool.vue?vue&type=style&index=0&id=ef913396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef913396",
  null
  
)

/* custom blocks */
import block0 from "./box-tool.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports